import { useCallback, useState } from "react"
import { Box, Button, Chip, CircularProgress } from "@mui/material"
import VolumeOffIcon from "@mui/icons-material/VolumeOff"
import VolumeUpIcon from "@mui/icons-material/VolumeUp"
import { format } from "date-fns"
import { useGetUserClanInfoTOHQuery, useUnmutePlayerTOHMutation } from "../../../core/api/toh-clans-api"
import TohMuteDialog from "../../BanControl/TohMuteDialog"

const TohFlaggedPlayerActionsCell = ({ playerId }) => {
    const [muteDialogOpen, setMuteDialogOpen] = useState(false)

    const { data: clanInfo, isLoading, refetch } = useGetUserClanInfoTOHQuery(playerId, { skip: !playerId })
    const [unmute, { isLoading: isUnmuting }] = useUnmutePlayerTOHMutation()

    const mutedUntil = clanInfo?.mutedUntil ?? null
    const isMuted = mutedUntil != null && new Date(mutedUntil * 1000) > new Date()
    const mutedUntilDate = isMuted ? new Date(mutedUntil * 1000) : null

    const handleUnmute = useCallback(async () => {
        await unmute({ userId: playerId })
        refetch()
    }, [playerId, unmute, refetch])

    const handleMuteClose = useCallback(() => {
        setMuteDialogOpen(false)
        refetch()
    }, [refetch])

    if (isLoading) {
        return <CircularProgress size={20}/>
    }

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {isMuted ? (
                <>
                    <Chip
                        size="small"
                        color="warning"
                        icon={<VolumeOffIcon/>}
                        label={`Muted until ${format(mutedUntilDate, "dd MMM yyyy HH:mm")}`}
                    />
                    <Button
                        size="small"
                        startIcon={<VolumeUpIcon/>}
                        loading={isUnmuting}
                        onClick={handleUnmute}
                    >
                        Unmute
                    </Button>
                </>
            ) : (
                <>
                    <Chip size="small" color="success" label="Not muted"/>
                    <Button
                        size="small"
                        startIcon={<VolumeOffIcon/>}
                        onClick={() => setMuteDialogOpen(true)}
                    >
                        Mute
                    </Button>
                </>
            )}
            <TohMuteDialog
                open={muteDialogOpen}
                playerId={playerId}
                onClose={handleMuteClose}
            />
        </Box>
    )
}

export default TohFlaggedPlayerActionsCell
